<template>
  <div class="job-detail-wrapper">
    <div class="detail-info">
      <div class="flex-between job-header">
        <span class="job-title">{{ detailData.job_post }}</span>
        <span class="job-salary">{{ detailData.display_salary }}</span>
      </div>
      <div class="flex-start job-content">
        <p class="city-list" v-if="detailData.city_names && detailData.city_names.length">
          <span v-for="(item, index) in detailData.city_names" :key="index">{{ item }}</span>
        </p>
        <p v-else>全国</p>
        <p>{{ detailData.display_experience | experienceFilter }}</p>
        <p>{{ detailData.degree_name | degreeFilter }}</p>
      </div>
    </div>
    <div class="company-info flex">
      <img :src="detailData.company_logo" alt="">
      <div class="flex-column company">
        <p class="company-title">{{ detailData.company_nick_name ||  detailData.company_name }}</p>
        <p class="flex-start company-detail-info">{{ detailData.company_nature }} {{ detailData.company_industry }} {{
          detailData.company_scale }}
        </p>
      </div>
    </div>
    <div class="job-description" v-if="detailData.jd">
      <p class="info-title flex-start">职位详情</p>
      <div v-html="replaceHtml(detailData.jd)" class="description"></div>
    </div>
    <div class="job-address">
      <p class="info-title flex-start">详细地址</p>
      <div class="address-container">
        <p class="address" v-for="(item, index) in detailData.city_address" :key="index">{{ item }}</p>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'job-detail-recommend',
		props: {
			detailData: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data () {
			return {}
		},
		filters: {
			degreeFilter (val) {
				if (!val || val.includes('不限')) {
					return '学历不限'
				} else {
					return val
				}
			},
			experienceFilter (val) {
				if (!val || val.includes('不限')) {
					return '经验不限'
				} else {
					return val
				}
			},
		},
		methods: {
			replaceHtml (val) {
				let dealVal = val.replace(/<br>/gi, '')
				let arr = dealVal.split('\n')
				let str = ''
				for (let i = 0; i < arr.length; i++) {
					if (arr[i]) str += `<p>${ arr[i] }</p>`
				}
				return str
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .job-detail-wrapper {
    .detail-info {
      margin-bottom: 22px;
      .job-header {
        align-items: flex-start;
        margin-bottom: 8px;
        .job-title {
          color: $color-title;
          font-size: 20px;
          line-height: 30px;
          font-weight: bold;
          max-width: 65%;
        }
        .job-salary {
          color: $color-theme;
          line-height: 24px;
          white-space: nowrap;
        }
      }
      .job-content {
        p {
          color: $color-dark-gray;
          line-height: 20px;
          &:after {
            content: '|';
            margin: 0 4px;
          }
          &:last-child:after {
            content: '';
          }
          span {
            color: $color-dark-gray;
          }
        }
      }
    }
    .company-info {
      margin-bottom: 34px;
      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
        border-radius: 2px;
        border: 1px solid #e3e3e3;
        margin-right: 8px;
      }
      .company {
        /*height: 40px;*/
        /*justify-content: space-between;*/
        .company-title {
          color: $color-dark-gray;
          font-size: $font-size-medium-x;
          line-height: 22px;
          margin-bottom: 4px;
        }
        .company-detail-info {
          word-break: break-all;
          color: $color-dark-gray;
          font-size: $font-size-small;
          line-height: 18px;
          /*margin-right: 4px;*/
        }
      }
    }
    .job-description {
      margin-bottom: 24px;
      .description {
        color: $color-dark-gray;
        font-size: $font-size-medium-x;
        line-height: 32px;
        word-break: break-all;
        /deep/ * {
          word-break: break-all;
          font-size: $font-size-medium;
        }
        /deep/ p {
          min-height: 32px;
        }
      }
    }
    .job-address {
      .address {
        color: $color-dark-gray;
        font-size: $font-size-medium;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .info-title {
      color: $color-title;
      font-size: $font-size-large;
      line-height: 26px;
      margin-bottom: 16px;
      font-weight: bold;
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background-color: #EEF0F5;
        margin-left: 14px;
      }
    }
  }
</style>
